import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/BonusTiers/GET';

export const BONUS_TIERS_GET_SUCCESS = `${rootActionPath}_${SUCCESS_SUFFIX}`;
export const BONUS_TIERS_GET_FAILURE = `${rootActionPath}_${FAILURE_SUFFIX}`;
